import CssBaseline from '@mui/material/CssBaseline'
import App from 'next/app'
import Router from 'next/router'
import NProgress from 'nprogress'
import React from 'react'
import { SendSchoolLog } from '../services/schoolLogs'
import theme from '../src/theme'
import ErrorComponent from './_error'
import V0MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import getMuiTheme from 'material-ui/styles/getMuiTheme'
import lightBaseTheme from 'material-ui/styles/baseThemes/lightBaseTheme'
import {
  createTheme,
  StyledEngineProvider,
  Theme,
  ThemeProvider,
} from '@mui/material/styles'
import { analytics } from '../services/firebase'
import { envConfig } from '../services/envConfig'
import { SentryService } from '../services/sentry-service'

import '../public/static/Typist.css'
import '../public/static/nprogress.css'
import { SchoolProvider } from '../context/SchoolContext'

declare module '@mui/styles/defaultTheme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}

Router.events.on('routeChangeStart', (url: any) => {
  console.log(`Loading: ${url}`)
  // SendSchoolLog();
  NProgress.start()
})
Router.events.on('routeChangeComplete', () => {
  NProgress.done()
  // (window as any)?.HubSpotConversations?.widget?.refresh?.();
  SendSchoolLog({})
  refreshHubspot()
  SentryService.setUser()
})
Router.events.on('routeChangeError', () => {
  NProgress.done()
  refreshHubspot()
})

function refreshHubspot() {
  if (typeof window === 'undefined') {
    return
  }
  setTimeout(() => {
    ;(window as any)?.HubspotConversations?.widget?.refresh?.()
  }, 3000)
}

// let hostName = "";

function overwriteConsole() {
  window.console.log = () => {}
}

export default class MyApp extends App {
  constructor(props: any) {
    super(props)
  }

  componentDidMount() {
    // Remove the server-side injected CSS.
    const jssStyles = document.querySelector('#jss-server-side')
    if (jssStyles && jssStyles.parentNode) {
      jssStyles.parentNode.removeChild(jssStyles)
    }
    if (envConfig.NEXT_PUBLIC_NODE_ENV === 'production') {
      analytics()

      // added it in componentDidMount to only clear logs on browser
      overwriteConsole()
    }
  }

  render() {
    const { Component, pageProps, error }: any = this.props

    if (error) {
      return <ErrorComponent statusCode={404} />
    }

    return (
      <>
        <SchoolProvider>
          <V0MuiThemeProvider muiTheme={getMuiTheme(lightBaseTheme)}>
            <StyledEngineProvider injectFirst>
              <ThemeProvider theme={createTheme(theme)}>
                <CssBaseline />
                {/* Pass pageContext to the _document though the renderPage enhancer
                    to render collected styles on server-side. */}
                <Component {...pageProps} />
              </ThemeProvider>
            </StyledEngineProvider>
          </V0MuiThemeProvider>
        </SchoolProvider>
      </>
    )
  }
}
